/* unplugin-vue-components disabled */import script from "./CinemaListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CinemaListItem.vue?vue&type=script&lang=ts&setup=true"

import "./CinemaListItem.vue?vue&type=style&index=0&id=475be51f&lang=scss"

const __exports__ = script;

export default __exports__